import { render, staticRenderFns } from "./amount.vue?vue&type=template&id=121eb245&scoped=true&"
import script from "./amount.vue?vue&type=script&lang=js&"
export * from "./amount.vue?vue&type=script&lang=js&"
import style0 from "./amount.vue?vue&type=style&index=0&id=121eb245&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121eb245",
  null
  
)

export default component.exports